import type { IImageCategorySize } from "@/store/types";

export enum ImageObjectTypes {
  PRODUCT = "product",
  PRODUCT_CATEGORY = "product_category",
  USER = "user",
  BRAND = "brand",
  BRAND_FAVICON = "favicon",
  BRAND_EMAIL_LOGO = "brandEmailLogo",
  CLIENT = "client",
  ORGANIZATION = "organisation",
  CLIENT_CUSTOM_FIELD = "client_custom_field",
  PARENT_IMAGES = "parent_images",
  PARENT_IMAGES_EMAIL_LOGO = "parent_images_email_logo",
  PARENT_IMAGES_FAVICON = "parent_images_favicon",
  PARENT_IMAGES_LOGO = "parent_images_logo",
  PARENT_IMAGES_LOGOMARK = "parent_images_logomark"
}

export enum ImageSubTypes {
  IMAGE = "image",
  ICON = "icon",
  LOGO = "logo",
  LOGOMARK = "logomark",
  FAVICON = "favicon",
  EMAIL_LOGO = "email_logo"
}

export interface IGalleryImageType {
  default: boolean;
  id: string;
  image_category_id: IImageCategorySize["id"];
  hash: string;
  order: number;
  isUploading?: boolean;
  exists?: boolean;
}
